import type { JSX } from 'react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Alert } from '@feathr/components';

function BillingMigrationAlert(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Alert title={t('Update to our billing system')} type={'info'}>
      <Trans t={t}>
        <p>You will receive an email with a link to configure your preferred payment method.</p>
        <p>
          For any questions, contact us at <strong>accounting@feathr.co</strong>.
        </p>
      </Trans>
    </Alert>
  );
}

export default BillingMigrationAlert;
